import { useEffect } from "react";
import { useI18n } from "../i18n/I18nContext";
import { useLocation } from "react-router-dom";
import { toEnPath, toNlPath } from "../i18n/slugs";

const SITE_URL = "https://tpagency.co";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ k }) => {
  const { t, lang } = useI18n();
  const { pathname } = useLocation();
  useEffect(() => {
    const m = t.seo[k];
    if (!m) return;
    document.title = m.title;
    setMeta("name", "description", m.desc);
    document.documentElement.lang = lang;

    const isNlPath = pathname === "/nl" || pathname.startsWith("/nl/");
    const enPath = isNlPath ? toEnPath(pathname) : pathname;
    const enUrl = `${SITE_URL}${enPath}`;
    const nlUrl = `${SITE_URL}${toNlPath(enPath)}`;
    const url = lang === "nl" ? nlUrl : enUrl;

    setLink("canonical", url);
    setLink("alternate", enUrl, "en");
    setLink("alternate", nlUrl, "nl-NL");
    setLink("alternate", enUrl, "x-default");

    setMeta("property", "og:title", t.og.title);
    setMeta("property", "og:description", t.og.desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${SITE_URL}/og-image.png`);
    setMeta("name", "twitter:title", t.og.title);
    setMeta("name", "twitter:description", t.og.desc);
  }, [t, k, lang, pathname]);
  return null;
};
